import { takeLatest } from 'redux-saga/effects';

import {
  ON_REPORTS_MOUNT,
  ON_REPORTS_MOUNT_ERROR,
  REPORTS_DOWNLOAD_QUICK_REPORT,
  ON_REPORTS_DOWNLOAD_STARTED,
  ON_REPORTS_SELECT_CUSTOM_EVENTS_COMPLETE,
  DELETE_CUSTOM_REPORT,
  ON_REPORTS_SAVE_STARTED
} from '../actions';

import {
  onReportsMount,
  downloadQuickReport,
  downloadCustomReport,
  setCustomEvents,
  saveReport,
  deleteReport,
  redirectToSignIn
} from './sagas';

export function* onReportsMountWatcher() {
  yield takeLatest(ON_REPORTS_MOUNT, onReportsMount);
}

export function* onDownloadReport() {
  yield takeLatest(ON_REPORTS_DOWNLOAD_STARTED, downloadCustomReport);
}

export function* onSaveReport() {
  yield takeLatest(ON_REPORTS_SAVE_STARTED, saveReport);
}

export function* reportsDownloadReportInit() {
  yield takeLatest(REPORTS_DOWNLOAD_QUICK_REPORT, downloadQuickReport);
}

export function* onReportsSelectCustomEventsComplete() {
  yield takeLatest(ON_REPORTS_SELECT_CUSTOM_EVENTS_COMPLETE, setCustomEvents);
}

export function* onDeleteReport() {
  yield takeLatest(DELETE_CUSTOM_REPORT, deleteReport);
}

export function* redirectToSignInOnReportsMountError() {
  yield takeLatest(ON_REPORTS_MOUNT_ERROR, redirectToSignIn);
}



// WEBPACK FOOTER //
// ./src/modules/reports/actions/watchers.js